import React from "react";
import { Link } from "react-router-dom";

interface FAQCardMobileProps {
  heading: string;
  Questions: string[];
  linkTo: string;
}

const FAQCardMobile: React.FC<FAQCardMobileProps> = ({
  heading,
  Questions,
  linkTo,
}) => {
  // Calculate max width based on longest question
  const maxQuestionWidth = Math.max(...Questions.map((q) => q.length)) * 9 - 25;
  const cardWidth = Math.max(280, maxQuestionWidth + 48);

  return (
    <div
      className="flex-shrink-0 rounded-[24px] p-4 pt-6 transition-all duration-300 h-full
        bg-white hover:bg-[#F0FFE7] active:bg-[#F0FFE7]
        shadow-[0px_4px_12px_rgba(0,0,0,0.08)]"
      style={{ width: `${cardWidth}px` }}
    >
      <div className="flex flex-col h-full justify-between">
        <div>
          <h2 className="font-helveticaBold text-[20px] leading-[28px] text-[#21272A] mb-4">
            {heading}
          </h2>

          <div className="flex flex-col gap-2">
            {Questions.map((question, index) => (
              <p
                key={index}
                className="font-helvetica font-medium text-[14px]  leading-[22px] text-[#697077] text-left whitespace-nowrap"
                style={{
                  fontFamily: "Helvetica Neue",
                  textUnderlinePosition: "from-font",
                  textDecorationSkipInk: "none",
                }}
              >
                {question}
              </p>
            ))}
          </div>
        </div>

        <Link
          to={linkTo}
          className="font-helveticaMedium text-[14px] leading-[20px] px-4 py-2 flex-start rounded-lg w-fit mt-6 border border-gray-300
            bg-white text-[#21272A] shadow-sm 
            hover:bg-[#4CAF32] hover:text-white hover:shadow-none
            active:bg-greenButtonColor active:text-white active:shadow-none
            transition-all duration-300"
        >
          Find Answers
        </Link>
      </div>
    </div>
  );
};

export default FAQCardMobile;
